import React from 'react';
import { Home, Settings2, MessageCircle, Info, Heart } from 'lucide-react';

const WHATSAPP_URL = 'https://wa.me/919902506684?text=Hi%2C%20I%20want%20to%20place%20a%20grocery%20order';

const navItems = [
  { icon: Home, label: 'Home', href: '#' },
  { icon: Settings2, label: 'How', href: '#how-it-works' },
  { icon: Heart, label: 'Why Us', href: '#why-us' },
  { icon: Info, label: 'About', href: 'mailto:hello@oneclickessentials.com' },
];

export default function MobileBottomNav() {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-border safe-bottom">
      <div className="flex items-center justify-around py-2 pb-[env(safe-area-inset-bottom,8px)]">
        {navItems.map(({ icon: Icon, label, href }, i) => (
          <a
            key={i}
            href={href}
            className="flex flex-col items-center gap-0.5 px-3 py-1 text-muted-foreground hover:text-primary transition-colors"
          >
            <Icon className="h-5 w-5" strokeWidth={1.5} />
            <span className="text-[10px] font-medium">{label}</span>
          </a>
        ))}
        {/* WhatsApp CTA - stands out */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center gap-0.5 px-3 py-1 text-primary"
        >
          <span className="flex items-center justify-center h-8 w-8 rounded-full bg-primary text-white -mt-4 shadow-lg">
            <MessageCircle className="h-4 w-4" strokeWidth={2} />
          </span>
          <span className="text-[10px] font-semibold">Order</span>
        </a>
      </div>
    </nav>
  );
}
